function hasPrefix(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr.length; j++) {
      if (i !== j && arr[j].startsWith(arr[i])) {
        return true;
      }
    }
  }
  return false;
}

let sortingval = '';

if ($(window).width() > 1007) {
  $(".main_grouped_filters button.Collapsible__Button").click(function () {
    $(this).parents(".main_grouped_filters .Collapsible.Collapsible--padded").find(".collaps_inner_grouped").toggleClass("active_filter");
    $(this).toggleClass("active");
  });
  $(document).on("click", "button.sidebar_filter_heading", function () {
    $('.custom_sidebar_filter').toggleClass('active');
    $(this).toggleClass('active');
  });
  $(document).on("click", "button.sidebar_sorting_heading", function () {
    $('.custom_sidebar_sorting').toggleClass('active');
    $(this).toggleClass('active');
  });
}
if ($(window).width() < 1008) {
  $(document).on("click", ".sorting_header", function () {
    $('.mobile_filter_sorting-main').addClass('active');
  });
  $(document).on("click", ".mobile_cross", function () {
    $('.mobile_filter_sorting-main').removeClass('active');
    $("html").removeClass("no-scroll");
  });
  $("button.Drawer__Close.Icon-Wrapper--clickable").click(function () {
    $("div#collection-filter-drawer").attr("aria-hidden", "true");
  });
}

$(document).on("click", '.main_grouped_filters .filter_Here', function () {
  let collectionUrl = $('.main_grouped_filters').data('collection-url');
  let activeTags = [];
  let clickLiThis = this;
  let getActiveFilter = '';
  let getSortBy = '?sort_by=created-descending';
  if ($('#collection-sort-popover').find('.is-selected').length) {
    getSortBy = $('#collection-sort-popover').find('.is-selected').attr('data-value');
    getSortBy = '?sort_by=' + getSortBy;
  }
  $(clickLiThis).toggleClass('activeFilter').toggleClass('is-selected').siblings().removeClass('activeFilter').removeClass('is-selected');
  setTimeout(function () {
    $(document).find('.main_grouped_filters[data-layout="desktoplayout"]').find('.activeFilter').each(function () {
      getActiveFilter = $(this).attr('data-filter');
      activeTags.push(getActiveFilter);
    });
    let tagsUrl = activeTags.join('+');
    if (hasPrefix("collection_")) {
      collectionUrl = `/collections/${collectionUrl.split('/')[collectionUrl.split('/').length - 1]}`;
    }
    let newUrl = collectionUrl;
    if (tagsUrl) {
      newUrl += '/' + tagsUrl;
    }
    sortingval = newUrl;
    newUrl = newUrl + getSortBy;
    newUrl = newUrl.replace("+?", "?");
    $.get({
      url: newUrl,
      success: function (data) {

        setTimeout(() => {
          document.querySelector('.collection__products .grid-outer').innerHTML = (new DOMParser).parseFromString(data, 'text/html').querySelector('.collection__products .grid-outer').getHTML();
        }, 1000);
        let newProductsWrapper = $(data).find(".all_collections");
        let newProductsHtml = newProductsWrapper.html();
        $('.all_collections.ProductListWrapper').html(newProductsHtml);
        $('.reset_fillter-button').show();
        $(".custom_reset_btn").show();
        history.pushState({
          page: newUrl
        }, null, newUrl);

         var endlessScroll = new Ajaxinate({
            container: '.Huratips-Loop',
            pagination: '.Huratips-Pagination'
          });

          setTimeout(function(){
            var endlessScroll = new Ajaxinate({
              container: '.Huratips-Loop',
              pagination: '.Huratips-Pagination'
            });
          }, 3000);

          var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
          if(loadresult == false){
            var unavailabledata =''; 
            $(".produts-unavailable").each(function(){
              var current = $(this).html();
              unavailabledata +=current;
            });
            
            //            $("#Huratips-Loop .grid__item").each(function(){
            //           var current_class = $(this).hasClass("end_image");
            //             if(current_class){}
            //             else{
            //             $(this).addClass("for_hidden");
            //             }
            //         });
            
            
            $("#Huratips-Loop").append(unavailabledata);
          }

      
      }
    });
  }, 250);
});


$(document).on("click", "#collection-sort-popover .filter_Here", function () {
  let thisVal = '?sort_by=' + $(this).attr('data-value');
  let getCurrent = window.location.href;
  getCurrent = getCurrent.split('?')[0];
  if (getCurrent) {
    getCurrent = getCurrent + thisVal;
  }
  $.get({
    url: getCurrent,
    success: function (data) {
      setTimeout(() => {
        document.querySelector('.collection__products .grid-outer').innerHTML = (new DOMParser).parseFromString(data, 'text/html').querySelector('.collection__products .grid-outer').getHTML();
      }, 1000);
      let newProductsWrapper = $(data).find(".all_collections");
      let newProductsHtml = newProductsWrapper.html();
      $('.all_collections.ProductListWrapper').html(newProductsHtml);
      history.pushState({
        page: getCurrent
      }, null, getCurrent);

       var endlessScroll = new Ajaxinate({
          container: '.Huratips-Loop',
          pagination: '.Huratips-Pagination'
        });

  
        setTimeout(function(){
          var endlessScroll = new Ajaxinate({
            container: '.Huratips-Loop',
            pagination: '.Huratips-Pagination'
          });
        }, 3000);

      var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
      if(loadresult == false){
        var unavailabledata =''; 
        $(".produts-unavailable").each(function(){
          var current = $(this).html();
          unavailabledata +=current;
        });
        
//           $("#Huratips-Loop .grid__item").each(function(){
//           var current_class = $(this).hasClass("end_image");
//             if(current_class){}
//             else{
//             $(this).addClass("for_hidden");
//             }
//         });
        
        
        $("#Huratips-Loop").append(unavailabledata);
      }
    }
  });
});

$(document).on("click", '.reset_fillter-button, .custom_reset_btn', function () {
  let collectionUrl = $('.main_grouped_filters').data('collection-url');
  $.get({
    url: collectionUrl,
    success: function (data) {
      setTimeout(() => {
        document.querySelector('.collection__products .grid-outer').innerHTML = (new DOMParser).parseFromString(data, 'text/html').querySelector('.collection__products .grid-outer').getHTML();
      }, 1000);
      let newProductsWrapper = $(data).find(".all_collections");
      let newProductsHtml = newProductsWrapper.html();
      $('.all_collections.ProductListWrapper').html(newProductsHtml);
      $("button.triggeredOne.CollectionToolbar__Item span").text('');
      $('.reset_fillter-button').hide();
      $(".custom_reset_btn").hide();
      history.pushState({
        page: collectionUrl
      }, null, collectionUrl);


       var endlessScroll = new Ajaxinate({
          container: '.Huratips-Loop',
          pagination: '.Huratips-Pagination'
        });

  
        setTimeout(function(){
          var endlessScroll = new Ajaxinate({
            container: '.Huratips-Loop',
            pagination: '.Huratips-Pagination'
          });
        }, 3000);

      var loadresult = $("#Huratips-Pagination a").hasClass("load-more-btn");
      if(loadresult == false){
        var unavailabledata =''; 
        $(".produts-unavailable").each(function(){
          var current = $(this).html();
          unavailabledata +=current;
        });
        
//           $("#Huratips-Loop .grid__item").each(function(){
//           var current_class = $(this).hasClass("end_image");
//             if(current_class){}
//             else{
//             $(this).addClass("for_hidden");
//             }
//         });
        
        
        $("#Huratips-Loop").append(unavailabledata);
      }
      $(document).find('.filter_Here').each(function () {
        $(this).removeClass('activeFilter').removeClass('is-selected');
      });
    }
  });
});

$(".collection__products .underlay").on("click", function (e) {
  $('.collection__sidebar__slide-out').removeClass('expanded');
});

$(".collection__sidebar__close").on("click", function (e) {
  $('.collection__sidebar__slide-out').removeClass('expanded');
});

$('.popout--group').on("click", function (e) {
  setTimeout(() => {
    document.querySelector('body').style.overflowY = "auto";
  }, 500);
})